/** Os idiomas da plataforma (`SUPPORTED_LOCALES`), com o nome que a tela mostra. */
export const IDIOMAS = [
  { valor: 'pt-BR', rotulo: 'Português (Brasil)' },
  { valor: 'en', rotulo: 'Inglês' },
  { valor: 'es', rotulo: 'Espanhol' },
];

/** O nome do idioma; o código cru se for um que a lista não conhece. */
export function rotuloDoIdioma(codigo: string) {
  return IDIOMAS.find((i) => i.valor === codigo)?.rotulo ?? codigo;
}
